import React from "react";
import {Grid} from "@mui/material";
import {SetState} from "../../util/FormHandlers";
import {filterSerializer} from "../../util/FilterSerializer";
import {TextSearchFilter} from "../../components/filter-fields/TextSearchFilter";
import {ClearFilterButton} from "../../components/filter-fields/ClearFilterButton";
import {filterOfficeVisitReport} from "../../util/visit/VisitReportSheetUtil";
import {filterDateRange, filterText} from "../../util/FilterUtil";
import {numberCmp} from "../../util/SortUtil";
import {ContractorVisitSheet} from "../../api/ContractorVisitStore";
import {workDayVisitCounter} from "../employee-visit-report/EmployeeVisitReportFilter";
import {DateRangeFilter, DateRangeOption, DateRangeOptions} from "../../components/filter-fields/DateRangeFilter";

export interface ContractorVisitReportFilterForm {
    dateRange: DateRangeOption;
    search: string;
}

export const emptyContractorVisitReportFilter: ContractorVisitReportFilterForm = {
    dateRange: DateRangeOptions.lastThreeMonths,
    search: '',
};

export const contractorVisitReportFilterSerializer = filterSerializer<ContractorVisitReportFilterForm>(
    emptyContractorVisitReportFilter,
    builder => {
        builder.dateRange('dateRange');
        builder.str('search');
    },
);

export function filterContractorVisitReport(
    sheet: ContractorVisitSheet,
    filter: ContractorVisitReportFilterForm,
): ContractorVisitSheet {
    const filteredSheet = filterOfficeVisitReport(
        sheet,
        filterDateRange(filter.dateRange),
        filterText(filter.search, contractor => [
            contractor.fullName,
            contractor.company,
        ]),
    );
    const countPercent = workDayVisitCounter(filteredSheet.dates);
    const rows = filteredSheet.rows
        .map(row => ({...row, visitPercent: countPercent(row).percent}))
        .sort(numberCmp(row => row.visitPercent ?? 0, true));
    return {...filteredSheet, rows};
}

export function ContractorVisitReportFilter({filter, setFilter}: {
    filter: ContractorVisitReportFilterForm;
    setFilter: SetState<ContractorVisitReportFilterForm>;
}) {
    return (
        <Grid container spacing={2} alignItems="center">
            <DateRangeFilter filter={filter} setFilter={setFilter} property="dateRange"/>
            <TextSearchFilter filter={filter} setFilter={setFilter} property="search"/>
            <ClearFilterButton emptyFilter={emptyContractorVisitReportFilter} setFilter={setFilter}/>
        </Grid>
    );
}
